import $ from "jquery";
import "../bootstrap.js";
window.$ = $;
window.jQuery = $;

document.addEventListener("DOMContentLoaded", async () => {
    const graduationWorksEls = document.querySelectorAll(
        ".js-graduation-works-slider"
    );
    const { renderGraduationWorksSlider } = await import(
        "../components/slider.js"
    );
    console.log("asdsad");

    graduationWorksEls.forEach((el) => {
        renderGraduationWorksSlider(el);
    });

    const anchorEl = document.querySelectorAll(".handle-anchor");
    if (anchorEl) {
        console.log(anchorEl);

        const { initAnchorLink } = await import("../components/anchorlink.js");
        initAnchorLink();
    }
});
